import type { AppRole } from "@/hooks/useRole";

export type ClinicRoleRow = { role_value: string; is_veterinarian: boolean; is_groomer: boolean };

/** Same compatibility mapping useRole always had, now fed by the clinic-level role. */
export function toAppRole(row: ClinicRoleRow | null): AppRole | null {
  if (!row) return null;
  if (row.role_value === "owner" || row.role_value === "admin") return "admin";
  if (row.role_value === "veterinary" || row.is_veterinarian) return "veterinarian";
  if (row.role_value === "groomer" || row.is_groomer) return "groomer";
  if (row.role_value === "receptionist") return "receptionist";
  return "user";
}

export function isVeterinarianRole(row: ClinicRoleRow | null): boolean {
  if (!row) return false;
  return row.role_value === "veterinary" || (row.role_value === "admin" && row.is_veterinarian);
}

export async function fetchMyClinicRole(clinicId: string): Promise<ClinicRoleRow | null> {
  // Lazy import keeps the pure helpers above importable (tests) without a configured Supabase client.
  const { supabase } = await import("@/integrations/supabase/client");
  const { data, error } = (await (supabase as never as {
    rpc: (fn: string, args: object) => Promise<{ data: ClinicRoleRow[] | null; error: unknown }>;
  }).rpc("get_my_clinic_role", { p_clinic_id: clinicId }));
  if (error) throw error;
  return data?.[0] ?? null;
}
